import React from 'react';

// Full-viewport modal shown when the chat WebSocket has gone stale and
// the person is still on the page; returning to the tab reconnects
// without it (hooks/useReconnectOnReturn). Mounted by ChatInterface; gated on
// `connectionStatus === 'stale'` — the initial "connecting" state still
// renders as an inline hint, not a modal. Also reached when a first
// handshake never completes (envelope-key-resend's handshake watchdog).
//
// The backdrop absorbs all pointer events — output-panel cards and
// widgets stay visually behind it but cannot be tapped through.
// Reconnect button dispatches the same connectWebSocket() the
// stale-send-button used to.
const DisconnectedOverlay = ({ onReconnect }) => {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Disconnected — reconnect to continue"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        // Light touch: a faint scrim + slight blur so the room stays
        // legible behind the prompt. Prompt sits near the bottom edge
        // (flex-end) rather than dead-center.
        background: 'rgba(20, 20, 20, 0.08)',
        backdropFilter: 'blur(1px)',
        WebkitBackdropFilter: 'blur(1px)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          background: '#ffffff',
          borderRadius: '14px',
          padding: '28px 32px 24px',
          maxWidth: '380px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 20px 48px rgba(0, 0, 0, 0.28)',
        }}
      >
        {/* Wifi icon + "Disconnected" headline removed (UI tweak) — the
            message + Reconnect button carry the meaning on their own. */}
        <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '20px', lineHeight: 1.45 }}>
          Your session went idle. Reconnect to continue where you left off.
        </div>
        <button
          type="button"
          onClick={onReconnect}
          autoFocus
          style={{
            background: '#4a6079',   /* nav-mobile-menu: muted dark blue, same as Send/Ask */
            color: '#ffffff',
            border: 'none',
            borderRadius: '8px',
            padding: '10px 24px',
            fontSize: '0.95rem',
            fontWeight: 500,
            cursor: 'pointer',
            minWidth: '140px',
          }}
        >
          Reconnect
        </button>
      </div>
    </div>
  );
};

export default DisconnectedOverlay;
